import type { AppDispatch } from "store";
import {
  fetchCourseListForWeb,
  type CourseWebListParams,
} from "services/courseWebService";
import {
  setCourseWebLoading,
  setCourseWebData,
  setCourseWebError,
} from "./reducer";

// Thunk to call /course/listcourseforweb (no auth/token required)
export const fetchCourseListForWebThunk =
  (params: CourseWebListParams) => async (dispatch: AppDispatch) => {
    dispatch(setCourseWebLoading(true));
    try {
      const response = await fetchCourseListForWeb(params);

      if (response.success && response.data) {
        dispatch(
          setCourseWebData({
            courses: response.data.courses,
            pagination: response.data.pagination,
          })
        );
      } else {
        dispatch(
          setCourseWebError(
            response.message || "Failed to fetch courses for web"
          )
        );
      }
    } catch (error: any) {
      const message =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";
      dispatch(setCourseWebError(message));
    } finally {
      dispatch(setCourseWebLoading(false));
    }
  };


